import {APIURLLEGALES} from "../../const/backend"
import apiClient from "../../utils/apiClient";

class ApiServiceAdapter  {
  async fetchPrestador(idLetrado) {
    const url=APIURLLEGALES + `/prestador/listar?idUsuarioLetrado=${idLetrado||''}`
    const response = apiClient.get(url)
    const data = await response
    return data;
  }
}

export default ApiServiceAdapter;